// Tiny pub/sub bus for achievement unlock toasts. Lives in a module
// (same pattern as uiSounds) so any code path that detects an unlock.
// processAchievements in app.jsx, the admin dev tools. Can announce it
// without threading a callback through the component tree. The single
// subscriber is the AchievementUnlockToast host mounted in app.jsx.

const listeners = new Set();

export function pushAchievementToast(achievementId) {
  for (const cb of listeners) cb(achievementId);
}

export function onAchievementToast(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}
